import React from 'react';
import { FILE_CONSTRAINTS } from '../constants';

const FileUploadSection = ({ 
  formData, 
  handleFileChange 
}) => {
  return (
    <div className="col-span-full">
      <h3 className="text-black font-semibold mb-4 font-poppins text-lg flex items-center justify-center gap-2">
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
        Upload Document ({FILE_CONSTRAINTS.ALLOWED_EXTENSIONS.join(', ')})
      </h3>
      
      <div className="w-full">
        <input
          accept={FILE_CONSTRAINTS.ALLOWED_TYPES.join(',')}
          className="hidden"
          id="file-upload"
          type="file"
          onChange={handleFileChange}
        />
        <label htmlFor="file-upload" className="w-full">
          <div className="w-full px-4 py-3 border-2 border-dashed border-gray-300 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors duration-200 cursor-pointer text-center">
            <div className="flex flex-col items-center gap-2">
              <svg className="w-8 h-8 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
              <span className="text-sm font-medium text-gray-700 font-poppins">
                Click to upload or drag and drop
              </span>
              <span className="text-xs text-gray-500 font-poppins">
                {FILE_CONSTRAINTS.ALLOWED_EXTENSIONS.join(', ')} files only
              </span>
            </div>
          </div>
        </label>
        {formData.file && (
          <div className="mt-3 p-3 bg-green-50 border border-green-200 rounded-lg">
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
              <span className="text-sm font-medium text-green-800 font-poppins">
                Selected file: {formData.file.name}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FileUploadSection; 